<template>
<div>
    <v-tabs>
        <v-tab @click="activeTab = 'models'">Shared Models</v-tab>
        <v-tab @click="activeTab = 'functions'">Shared Functions</v-tab>
    </v-tabs>
    <div v-if="activeTab == 'models'">
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-text-field label="Search" v-model="searchModels"></v-text-field>
            <v-btn round color="primary" class="white--text" @click="shareNewModel">Share New Model</v-btn>
        </v-toolbar>
        <v-data-table :search="searchModels" :items="sharedModels" :headers="modelheaders">
            <template v-slot:items="props">
                <td class="justify-center layout px-0">
                    <v-icon class="mr-2" @click="editItem(props.item)">edit</v-icon>
                    <v-icon @click="deleteItem(props.item.id)">delete</v-icon>
                </td>
                <td class="text-xs-center">
                    {{ props.item.name }}
                </td>
                <td class="text-xs-center" @click="fetchAttributes(props.item.value)">
                    {{ props.item.value }}
                </td>
                <td class="text-xs-center">
                    {{ props.item.description }}
                </td>
                <td class="text-xs-center">
                    <v-chip>{{props.item.workflowModelSharedAttributes.length}}</v-chip>
                </td>
            </template>
        </v-data-table>
    </div>
    <div v-if="activeTab == 'functions'">
        <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-text-field label="Search" v-model="searchFunctions"></v-text-field>
        </v-toolbar>
         <v-data-table :items="sharedFunctions" :headers="functionHeaders" :search="searchFunctions" hide-actions item-key="value">
                    <template v-slot:items="props">
                        <td class="text-xs-center">
                            {{ props.item.value }}
                        </td>
                        <td class="text-xs-center">
                            {{ props.item.name }}
                        </td>
                        <td class="text-xs-left">
                            {{ props.item.description }}
                        </td>
                        <td class="text-xs-center">
                           <v-chip small style="height: 16px" outline v-for="param in props.item.parameters" :key="param">
                               {{param}}
                           </v-chip>
                        </td>
                        <td class="text-xs-center">
                            <v-chip color="blue" class="white--text" small>{{ props.item.tag }}</v-chip>
                        </td>
                    </template>
                </v-data-table>
    </div>

    <v-dialog v-model="shareNewModelModal" width="750px">
        <v-card flat color="white">
            <v-toolbar flat color="white">
                <v-toolbar-title>
                    Select a Model
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="modalSelected" flat color="black" @click="saveNew()">Save</v-btn>
                <v-btn flat @click="
              (shareNewModelModal = false), (item = {}), (modalSelected = false)
            ">X</v-btn>
            </v-toolbar>
            <v-card-text v-if="!modalSelected">
                <v-toolbar flat color="white">
                    <v-spacer></v-spacer>
                    <v-text-field label="Search" v-model="newModelSearch"></v-text-field>
                </v-toolbar>
                <v-data-table :search="newModelSearch" :items="models" :headers="newModelheaders" style="cursor: pointer">
                    <template v-slot:items="props">
                        <td class="text-xs-center" @click="updateLocalItem(props.item)">
                            {{ props.item.name }}
                        </td>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-text v-else>
                <h3>
                    Selected Model: <i>{{ item.value }}</i>
                </h3>
                <v-layout justify-center>
                    <v-flex xs6 px-1>
                        <v-text-field v-model="item.name" placeholder="Friendly Name"></v-text-field>
                    </v-flex>
                    <v-flex xs6 px-1>
                        <v-text-field v-model="item.description" placeholder="Description"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-data-table :items="item.attributes" :headers="headers" hide-actions select-all v-model="selectedAttributes" item-key="value">
                    <template v-slot:items="props">
                        <td>
                            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                        </td>
                        <td class="text-xs-center">
                            {{ props.item.value }}
                        </td>
                        <td class="text-xs-center">
                            <v-text-field placeholder="Name" style="font-size:12px" v-model="props.item.name"></v-text-field>
                        </td>
                        <td class="text-xs-center">
                            <v-text-field placeholder="Description" style="font-size:12px" v-model="props.item.description"></v-text-field>
                        </td>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="editModal" width="750px">
        <v-card flat color="white" v-if="item">
            <v-toolbar flat color="white">
                <v-toolbar-title>
                    Table: {{item.value}}

                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="item.id" @click="save(item)" outline flat color="black"> Save</v-btn>
                <v-btn icon @click="editModal=false, item={}">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center>
                    <v-flex xs6 px-1>
                        <v-text-field box v-model="item.name" label="Friendly Name"></v-text-field>

                    </v-flex>
                    <v-flex xs6 px-1>
                        <v-text-field box v-model="item.description" label="Description"></v-text-field>

                    </v-flex>
                </v-layout>
                <v-toolbar flat color="white">
                    <v-spacer></v-spacer>
                    <v-text-field label="Search" v-model="searchAttributes"></v-text-field>
                </v-toolbar>
                <v-data-table :items="item.attributes" :headers="headers" :search="searchAttributes" hide-actions select-all v-model="selectedAttributes" item-key="value">
                    <template v-slot:items="props">
                        <td>
                            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                        </td>
                        <td class="text-xs-center">
                            {{ props.item.value }}
                        </td>
                        <td class="text-xs-center">
                            <v-text-field placeholder="Name" style="font-size:12px" v-model="props.item.name"></v-text-field>
                        </td>
                        <td class="text-xs-center">
                            <v-text-field placeholder="Description" style="font-size:12px" v-model="props.item.description"></v-text-field>
                        </td>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import Api from "@/services/Api";
export default {
    data() {
        return {
            activeTab: "models",
            allModels: [],
            editModal: false,
            item: {},
            isEditing: false,
            models: [],
            sharedModels: [],
            searchModels: "",
            newModelSearch: "",
            shareNewModelModal: false,
            modalSelected: false,
            headers: [{
                    text: "Database Field",
                    align: "center",
                    value: "value",
                },
                {
                    text: "Name",
                    align: "center",
                    value: "name",
                },

                {
                    text: "Description",
                    align: "center",
                    value: "description",
                }
            ],
             functionHeaders: [
                 {
                    text: "Function",
                    align: "center",
                    value: "value",
                },
                {
                    text: "Name",
                    align: "center",
                    value: "name",
                },

                {
                    text: "Description",
                    align: "center",
                    value: "description",
                },
                {
                    text: "Parameters",
                    align: "center",
                    sortable: false
                },
                {
                    text: "Tag",
                    align: "center",
                    value: 'tag'
                }
            ],
            modelheaders: [{
                    text: "Actions",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "Name",
                    align: "center",
                    value: "name",
                },
                {
                    text: "Table",
                    align: "center",
                    value: "value",
                },
                {
                    text: "Description",
                    align: "center",
                    value: "description",
                },
                {
                    text: "Shared Attributes",
                    align: "center",
                    sortable: false
                }
            ],
            newModelheaders: [{
                text: "Name",
                align: "center",
                value: "name",
            }],
            sharedFunctions: [],
            searchFunctions: '',
            searchAttributes: '',
            selectedAttributes: []
        };
    },
    created() {
        this.initialize();

    },
    methods: {
        initialize() {
            this.fetchModels();
            this.fetchSharedModels();
            this.fetchSharedFunctions()
        },
        fetchModels() {
            Api()
                .get("/workflow/admin/models")
                .then((res) => {
                    this.allModels = res.data;
                    this.models = res.data;
                });
        },
        
        async fetchAttributes(value) {
            let result = []
            await Api().get('/tableAttributes/' + value).then(res => {
                result = Object.keys(res.data)
                result = result.map(x => ({
                    id: x.id,
                    name: x.name,
                    description: x.description,
                    value: x
                }))
            })
            return result
        },
        fetchSharedFunctions(){
            Api().get('/sharedFunctions').then(res=>{
                let keys = Object.keys(res.data)
                this.sharedFunctions = keys.map(x=>({name: res.data[x].name, description: res.data[x].description, value: x, parameters: res.data[x].parameters, tag: res.data[x].tag}))
                console.log(this.sharedFunctions)
            })
        },
        shareNewModel() {
            let sharedValues = this.sharedModels.map((x) => x.value);
            this.models = this.allModels.filter((x) => !sharedValues.includes(x));
            this.models = this.models.map(x => ({
                name: x
            }))
            this.item = {

            }
            this.shareNewModelModal = true;
        },
        fetchSharedModels() {
            Api()
                .get("/workflow/list/sharedModels")
                .then((res) => {
                    this.sharedModels = res.data;
                });
        },
        async updateLocalItem(value) {
            this.item.value = value.name;
            this.item.name = value.name;
            this.item.attributes = await this.fetchAttributes(value.name)
            this.modalSelected = true;
        },
        async editItem(item) {
            this.item = item
            this.item.attributes = await this.fetchAttributes(item.value)
            this.item.attributes.forEach(x=>{
                let find = this.item.workflowModelSharedAttributes.find(y=>y.value == x.value)
                if(find){
                    x.name = find.name
                    x.description = find.description
                }
            })
            this.selectedAttributes = this.item.workflowModelSharedAttributes
            this.editModal = true
        },
        deleteItem(id) {
            confirm("Are you sure you want to delete this item?") &&
                Api().put('/workflow/sharedModels/' + id, {
                    isActive: false,
                    isDeleted: true
                }).then(() => {
                    this.fetchSharedModels()
                })
        },
        async createAttributes(attributes) {
            let result = []
            await Api().post('/workflow/modelAttributes', {
                batch: attributes
            }).then(res => {
                result = res.data
            })
            return result
        },
        async deleteAttributes(attributes) {
            let result = []
            await Api().post('/workflow/delete/modelAttributes', {
                batch: attributes
            }).then(res => {
                result = res.data
            })
            return result
        },
        async saveNew() {
            Api()
                .post("/workflow/sharedModels", this.item)
                .then(async (res) => {
                    this.selectedAttributes.forEach(x => {
                        delete x.id
                        x.workflowSharedModelId = res.data.id
                    })
                    await this.createAttributes(this.selectedAttributes)
                    this.shareNewModelModal = false;
                    this.modalSelected = false;
                    this.item = {}
                    this.selectedAttributes = []
                    this.fetchSharedModels();
                })
        },
        async save(item) {
            Api()
                .put("/workflow/sharedModels/" + this.item.id, item)
                .then(async (res) => {
                    let removeModels = this.item.workflowModelSharedAttributes.map(x=>x.id)
                    let selectedModels = this.selectedAttributes.filter(x=>x.id).map(x=>x.id)
                    removeModels = removeModels.filter(x=>!selectedModels.includes(x))
                    this.selectedAttributes.forEach(x=>{
                        x.workflowSharedModelId = this.item.id
                    })
                    if(removeModels.length>0)
                        await this.deleteAttributes(removeModels)
                    if(this.selectedAttributes)
                        await this.createAttributes(this.selectedAttributes)

                    this.fetchSharedModels();
                    this.item = {};
                    this.editModal = false;
                });
        },
    },
};
</script>
